import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { FETCH_NFT_METADATA } from "../constants/urls";

const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const Title = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 26px;

    display: flex;
    align-items: center;

    color: #FFFFFF;
    text-align: center;

`;

async function fetchMetadata(contract, token){
    try{
        let resp = await fetch(FETCH_NFT_METADATA + `${contract}/${token}/`, {
	    method: 'GET',
	    headers: {
	        'Accept': 'application/json',
	        'Content-Type': 'application/json',
	    },
        });	    
        resp = await resp.json();
        return resp
    }
    catch(e){
        console.log('erororororo', e);
        return false;
    }
}


export default function PrimeOpensea(props) {
    const [socialConnectModalOpen,
        setSocialConnectModalOpen] = useState(false);
    const [connected, setIsConnected] = useState(false);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    const {contractAddress, tokenId} = useParams();
    const history = useHistory();
    const [glipbox, setGlipbox] = useState();
    const [name, setName] = useState();
    const [error, setError] = useState();
    console.log('sds')
    // Fetch data for remaing glipboxes
    useEffect(() => {
        const fetchApi = async () => {
            console.log('sds')
            const glipboxData = await fetchMetadata(contractAddress, tokenId);
            console.log('glipboxdata==============', glipboxData)
            setGlipbox(glipboxData);
        };

        fetchApi();
    }, []);


    // let url = glipbox.video_url;
    if(!glipbox)
        return (<></>)
    
    return (
        <>              
        <div style={{}}>           
            {/* <Title style={{justifyContent: 'center', width: '100%', marginTop: 40}}>CLAIM YOUR NFT PERKS</Title> */}
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100vh', alignSelf: 'center', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexWrap: 'wrap'}}>
                    <img
                        autoPlay
                        loop
                        style={{width: '100%', zIndex: -1, maxHeight: 260, borderRadius: 12, maxWidth: 260}}
                        src={glipbox.video_url}
                    />
                </div>
                <Title style={{marginTop: 12, textTransform: 'capitalize'}}>{glipbox.buyer_name}</Title>                              
            </div>
        </div>
        </>
    );
}

